import { render } from "./SignersDocument.vue?vue&type=template&id=79ca8b98"
import script from "./SignersDocument.vue?vue&type=script&lang=js"
export * from "./SignersDocument.vue?vue&type=script&lang=js"

import "./SignersDocument.vue?vue&type=style&index=0&id=79ca8b98&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__